export const PageTagline = ({ message }: { message: string }) => {
  return <div className="page-tagline">{message}</div>;
};
